module.exports = __webpack_public_path__ + "img/laslgqgkl.147755e9.png";